import { isArray, isObject, object } from '@art-suite/art-core-ts';

export const stripUpdatedAt = <T>(obj: T): T => {
  if (isArray(obj)) {
    return obj.map(stripUpdatedAt) as T;
  }
  if (isObject(obj)) {
    // Create a shallow copy of the object to avoid removing "updatedAt"
    // from the original object.
    let objCopy: any = { ...obj };
    if ('updatedAt' in objCopy) {
      delete objCopy.updatedAt;
    }
    return object(objCopy, stripUpdatedAt) as T;
  }
  return obj;
};
